import {
  BorderProps,
  ButtonProps,
  IconProps,
  LoadingSpinnerProps,
  TextProps,
} from 'spindl-shared-components';
import { ColumnHeadersProps } from '../../molecules/ColumnHeaders';
import { UserRowListProps } from '../../molecules/UserRowList';
import { UserListHeaderProps } from '../../organisms/UserListHeader';


type UserAccountListInternalProps = {
  userListHeader?: UserListHeaderProps;
  columnHeaders?: ColumnHeadersProps;
  userRowList?: UserRowListProps;
  border?: BorderProps;
  icon?: IconProps;
  title?: TextProps;
  instructions?: TextProps;
  button?: ButtonProps;
  loadingSpinner?: LoadingSpinnerProps;
};

type UserAccountListPropsValues = {
  'Default': UserAccountListInternalProps;
  'Empty': UserAccountListInternalProps;
  'NoResults': UserAccountListInternalProps;
  'Loading': UserAccountListInternalProps;
};

const propValues: UserAccountListPropsValues = {
  'Default': {
    userListHeader: {
    },
    columnHeaders: {
    },
    userRowList: {
    },
  },
  'Empty': {
    userListHeader: {
    },
    columnHeaders: {
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    icon: {
      asset: 'UsersFilled',
      colour: 'IconSubdued',
    },
    title: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading2',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
    button: {
      type: 'Text',
      size: 'L',
      styleType: 'Primary',
      state: 'Default',
    },
  },
  'NoResults': {
    userListHeader: {
    },
    columnHeaders: {
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    icon: {
      asset: 'SearchEmptyState',
      colour: 'IconSubdued',
    },
    title: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading2',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
  },
  'Loading': {
    loadingSpinner: {
      size: 'Large',
      styleType: 'Primary',
    },
  },
};

const getProps = (type: string): UserAccountListInternalProps => {
  const values: UserAccountListInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
